import React, { Fragment, createContext, useReducer, useEffect } from "react";
import { Navber, Footer } from "../partials";
import Sidebar from "./Sidebar";
import {
  dashboardUserState,
  dashboardUserReducer,
} from "./DashboardUserContext";
import { productState,productReducer } from "./ProductContext";
import { fetchData } from "./Action";

export const DashboardUserContext = createContext();
export const ProductContext = createContext();
const Layout = ({ children }) => {
  const [data, dispatch] = useReducer(dashboardUserReducer, dashboardUserState);
  const [data2,dispatch2] = useReducer(productReducer,productState);
  useEffect(() => {
    fetchData(dispatch);
  }, []);

  return (
    <Fragment>
      <ProductContext.Provider value={{data2,dispatch2}}>
      <DashboardUserContext.Provider value={{ data, dispatch }}>
        <div className="flex-grow">
          <Navber />
          <div className="mx-4 mt-24 md:mx-12 md:mt-32 lg:mt-24 flex flex-col md:flex-row">
            <Sidebar />
            {/* All Children pass from here */}
            {children}
          </div>
        </div>
        <Footer />
      </DashboardUserContext.Provider>
      </ProductContext.Provider>
    </Fragment>
  );
};

export default Layout;
